import { useState } from "react";
import { useAuth } from "../../../auth/AuthProvider";
import { downloadPortfolioExport } from "../api/portfolio";

interface Props {
  filters?: Record<string, string>;
}

export function ExportButton({ filters }: Props) {
  const { token } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    if (!token) return;
    setLoading(true);
    try {
      const blob = await downloadPortfolioExport(token, filters);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filters && Object.keys(filters).length > 0
        ? `portfolio_${Object.entries(filters).map(([k, v]) => `${k}-${v}`).join("_")}.xlsx`
        : "portfolio_export.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={loading}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-body-sm bg-surface-600 text-text-secondary hover:bg-surface-500 hover:text-text-primary transition-colors disabled:opacity-50"
    >
      <DownloadIcon />
      {loading ? "Exporting..." : "Export Excel"}
    </button>
  );
}

function DownloadIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  );
}
